/* eslint react/no-danger: 0 */
import React from 'react';
import { EMBEDLY_TYPE } from '../utilities/CONSTANTS';
import { sanitizeEmbedlyHTML } from '../../utilities/sanitizeHTML';

const Embed = (props) => {
    const { readOnly, embedly, src } = props;

    if ((embedly.type === EMBEDLY_TYPE.RICH || embedly.type === EMBEDLY_TYPE.VIDEO) && embedly.html) {
        const sanitizedHtml = sanitizeEmbedlyHTML(embedly.html);
        return (
            <div
                className="embedly"
                dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
            />
        );
    } if (embedly.type === EMBEDLY_TYPE.PHOTO) {
        return (<img src={embedly.url} alt="" />);
    }

    const content = (
        <div className="embedly-raw">
            <img className="embedly__thumbnail" src={embedly.thumbnail_url} height="50" alt="" />
            <div className="embedly__details">
                <div className="embedly__title">{embedly.title}</div>
                <div className="embedly__description">{embedly.description}</div>
            </div>
        </div>
    );

    if (readOnly) {
        return (
            <a href={src} target="_blank" rel="noopener noreferrer">
                {content}
            </a>
        );
    }

    return content;
};

class Embedly extends React.Component {
    getStyles = () => {
        const { editorState, block } = this.props;
        const contentState = editorState.getCurrentContent();
        const blockData = contentState.getBlockForKey(block.key).getData();
        return blockData.toJS();
    };

    render() {
        const { entity, readOnly } = this.props;
        const { src, embedly } = entity.getData();

        if (embedly) {
            if (embedly.type === EMBEDLY_TYPE.LINK) {
                return (
                    <iframe
                        className="tettra-iframe"
                        src={src}
                        frameBorder="0"
                        sandbox="allow-scripts allow-popups allow-forms allow-same-origin allow-presentation"
                        allowFullScreen=""
                        width="100%"
                        height="100%"
                    />
                );
            }

            return (
                <Embed readOnly={readOnly} embedly={embedly} src={src} />
            );
        }

        return (
            <div className="loading embedly">
                Loading:
                {' '}
                {src}
            </div>
        );
    }
}

export default Embedly;
